"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const cbor_1 = __importDefault(require("cbor"));
const cbor_2 = require("./cbor");
const cose_1 = require("./cose");
const error_1 = require("./error");
const attributes_1 = require("./attributes");
const const_1 = require("../const");
class Message {
    constructor(content) {
        this.content = content;
    }
    getContent() {
        return this.content;
    }
    getAsyncToken() {
        var _a;
        const attributes = attributes_1.Attributes.getFromMessage(this);
        return attributes
            ? (_a = attributes_1.AsyncAttribute.getFromAttributes(attributes)) === null || _a === void 0 ? void 0 : _a.getToken()
            : undefined;
    }
    getPayload() {
        var _a;
        return cbor_1.default.decode((_a = this.content) === null || _a === void 0 ? void 0 : _a.get(4), cose_1.decoders);
    }
    static fromObject(obj) {
        if (!obj.method) {
            throw new Error("Property 'method' is required.");
        }
        const content = new Map();
        if (obj.from) {
            content.set(1, obj.from);
        }
        if (obj.to) {
            content.set(2, obj.to);
        }
        content.set(3, obj.method);
        if (obj.data) {
            content.set(4, cbor_1.default.encodeOne(obj.data, {
                highWaterMark: const_1.HIGH_WATER_MARK,
            }));
        }
        content.set(5, (0, cbor_2.tag)(1, obj.timestamp ? obj.timestamp : Math.floor(Date.now() / 1000)));
        if (obj.id) {
            content.set(6, obj.id);
        }
        if (obj.nonce) {
            content.set(7, cbor_1.default.encode(obj.nonce));
        }
        if (obj.attrs) {
            content.set(8, obj.attrs);
        }
        return new Message(content);
    }
    static fromCoseMessage(message) {
        const content = message.content;
        const data = content.get(4);
        if (typeof data == "object" && !Buffer.isBuffer(data)) {
            throw new error_1.ManyError(Object.fromEntries(data.entries()));
        }
        return new Message(content);
    }
    static fromCborData(data) {
        const cose = cose_1.CoseMessage.fromCborData(data);
        return Message.fromCoseMessage(cose);
    }
    replacer(key, value) {
        if ((value === null || value === void 0 ? void 0 : value.type) === "Buffer") {
            return Buffer.from(value.data).toString("hex");
        }
        else if (value instanceof Map) {
            return Object.fromEntries(value.entries());
        }
        else if (typeof value === "bigint") {
            return parseInt(value.toString());
        }
        else if (key === "hash") {
            return Buffer.from(value).toString("hex");
        }
        else if (key === "bytes") {
            return Buffer.from(value).toString("hex");
        }
        else {
            return value;
        }
    }
    toCoseMessage(identity) {
        return cose_1.CoseMessage.fromMessage(this, identity);
    }
    async toCborData(identity) {
        return (await this.toCoseMessage(identity)).toCborData();
    }
    toString() {
        return JSON.stringify(this.content, this.replacer, 2);
    }
}
exports.Message = Message;
